import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const senecStepConnectorTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            line: {
                borderWidth: 2,
                position: "relative",
                top: 11,
            },
            root: {
                "&.Mui-completed": {
                    "& .MuiStepConnector-line": {
                        borderColor: theme.palette.deepBlue.main,
                    },
                },
                "&.Mui-active": {
                    "& .MuiStepConnector-line": {
                        borderColor: "transparent",
                        borderImage: `linear-gradient(to right, ${theme.palette.deepBlue.main} 50%, ${theme.palette.neutralGray40.main} 50%) 1`,
                    },
                },
                "&.Mui-disabled": {
                    "& .MuiStepConnector-line": {
                        borderColor: theme.palette.neutralGray40.main,
                    },
                },
            },
        },
    };
};
